import { KeyValuePair } from './conversation.interface';

export enum VideoMessageState {
  // Generic states — usable by any async video pipeline
  Processing = 'processing',
  Sending = 'sending',
  Sent = 'sent',
  Failed = 'failed',
  // MMS-specific states
  UploadInProgress = 'upload-in-progress',
  UploadRejected = 'upload-rejected',
  TranscodingFailed = 'transcoding-failed',
  OutputTooLarge = 'output-too-large',
  TwilioRejected = 'twilio-rejected',
}

export const VIDEO_STATE_METADATA_KEY = 'videoState';

export const VIDEO_ERROR_MESSAGE_KEYS: Partial<Record<VideoMessageState, string>> = {
  [VideoMessageState.Failed]: 'INBOX.VIDEO.ERROR.FAILED',
  [VideoMessageState.UploadRejected]: 'INBOX.VIDEO.ERROR.UPLOAD_REJECTED',
  [VideoMessageState.TranscodingFailed]: 'INBOX.VIDEO.ERROR.TRANSCODING_FAILED',
  [VideoMessageState.OutputTooLarge]: 'INBOX.VIDEO.ERROR.OUTPUT_TOO_LARGE',
  [VideoMessageState.TwilioRejected]: 'INBOX.VIDEO.ERROR.TWILIO_REJECTED',
};

export function isVideoMessage(metadata?: KeyValuePair[]): boolean {
  return !!metadata?.some((m) => m.key === VIDEO_STATE_METADATA_KEY);
}

const KNOWN_STATES: Set<string> = new Set(Object.values(VideoMessageState));

export function getVideoState(metadata?: KeyValuePair[]): VideoMessageState | undefined {
  const entry = metadata?.find((m) => m.key === VIDEO_STATE_METADATA_KEY);
  if (!entry) return undefined;
  return KNOWN_STATES.has(entry.value) ? (entry.value as VideoMessageState) : undefined;
}
